import React from "react";
import { Redirect } from "react-router-dom";
import { CDropdownMenu, CDropdownItem } from "@coreui/react";
import Storage from "../../Storage/AuthSession.js";
import { List, Button } from "rsuite";

export default class ProfilePopover extends React.Component {
  constructor(props) {
    super();

    this.state = {
      isLoggedIn: Storage.isLoggedIn(),
    };
    this.handleLoggeOut = this.handleLoggeOut.bind(this);
    console.log("LoggedOut..1");
  }
  componentDidMount() {}

  handleLoggeOut(e) {
    // alert("Hellle", e);
    console.log("LoggedOut..");
    //Storage.logOut();
    // this.setState({ isLoggedIn: false });
  }

  render() {
    const { isLoggedIn } = this.state;
    // const ProfileViewPopover = ({ content, ...props }) => {
    return (
      // <div>
      //   <CDropdownItem>Moses Wakanyi</CDropdownItem>
      //   <CDropdownItem>Account Settings</CDropdownItem>
      //   <CDropdownItem onChange={this.handleLoggeOut}>Logout</CDropdownItem>
      // </div>
      <List>
        <List.Item>Moses Wakanyi</List.Item>
        <List.Item>Account Settings</List.Item>
        <List.Item>
          <a href="#" onClick={this.handleLoggeOut}>
            Logout
          </a>
        </List.Item>
      </List>
    );
    // };

    // return <ProfileViewPopover />;
  }
}
